import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import VideoImageAnimationTriggerController from "./video_image_animation_trigger_controller";

export default class extends VideoImageAnimationTriggerController {
    static targets = ["swiper"]

    initialize() {
        super.initialize();

        const swiper = new Swiper(this.swiperTarget, {
            modules: [Pagination],
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
            }
        });
        
        swiper.on('slideChange', function (e) {
            if (e.activeIndex) {
                this.triggerReplayEvent(e.activeIndex)
            }
        }.bind(this));
    }
}